import * as validationLib from "../lib/validation";

export default function hasFailingValidation(validation: validationLib.Validation): boolean {
    if (validation.generic !== undefined && validation.generic.length > 0) {
        return true;
    }
    if (validation.errors) {
        if (Object.keys(validation.errors).length > 0) {
            return true;
        }
    }
    return false;
}
